"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShortenedText = void 0;
// (C) 2020-2021 GoodData Corporation
var ShortenedText_1 = require("./ShortenedText");
Object.defineProperty(exports, "ShortenedText", { enumerable: true, get: function () { return ShortenedText_1.ShortenedText; } });
//# sourceMappingURL=index.js.map